/**
 * ステージング用設定
 * ng build --configuration=stg
 */
export const environment = {
  production: true,
  envName: 'stg',
  apiUrl: 'https://api.stg.mach.doda.jp',
  rpaUserIds: [228, 381],
  myPageUrl: 'https://stg.student.doda.jp',
};
